import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { API_URL } from '../../Actions/Config'
import DatePicker from "react-datepicker";
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import { getRoundTourDetails } from "../../Actions/TourDetailsAction"
import { handleBooking } from "../../Actions/CheckoutAction"
import { tourFb, tourTw, tourLn } from "../../Images"
import PhotoGallery from "../Common/Gallery"
import "aos/dist/aos.css";
import "../../css/mainUpdate.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

const mapStateToProps = (state) => {
    return {
        tourDetailsReducer: state.TourDetailsReducer,
        CheckoutReducer: state.CheckoutReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getRoundTourDetails: (name) => dispatch(getRoundTourDetails(name)),
    handleBooking: (data, tour) => dispatch(handleBooking(data, tour))
});


function getURL(tour) {
    var url = ""
    url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + "tour.permalink"
    return url
}

function getBannerImages(tour) {
    var image = []
    if (tour != null && tour.itinerary_images.length > 0) {
        image = [
            API_URL + "/" + tour.itinerary_images[0].thumb,
            API_URL + "/" + tour.itinerary_images[0].thumb2,
            API_URL + "/" + tour.itinerary_images[0].thumb3,
            API_URL + "/" + tour.itinerary_images[0].thumb4,
            API_URL + "/" + tour.itinerary_images[0].thumb5,
        ].filter(Boolean);
    }
    return image
}

function getPrice(locGroup) {
    var price = 0
    for (let i = 0; i < locGroup.length; i++) {
        var cost = locGroup[i];

        if (cost.type == 0 && (price == 0 || price > cost.price)) {
            price = cost.price
        }
    }

    return price
}

function getAdultChild(locGroup, type) {
    var from_pax = 1000
    var pax = 0

    switch (type) {
        case "Adult":
            for (let index = 0; index < locGroup.length; index++) {
                const group = locGroup[index];
                if (group.type == 0 && group.to_number > pax) {
                    pax = group.to_number
                }
                if (group.type == 0 && group.from_number < from_pax) {
                    from_pax = group.from_number
                }
            }
            break;
        case "Child":
            for (let index = 0; index < locGroup.length; index++) {
                const group = locGroup[index];
                if (group.type == 1 && group.to_number > pax) {
                    pax = group.to_number
                }
                if (group.type == 1 && group.from_number < from_pax) {
                    from_pax = group.from_number
                }
            }
            break;

        default:
            break;
    }
    return { pax, from_pax }
}

function getDiscount(tour, date = null) {
    var discount = 0
    var nowDate = date == null ? new Date().setHours(0, 0, 0, 0) : date

    if (tour.item_discount.length > 0) {
        for (let i = 0; i < tour.item_discount.length; i++) {
            const item_discount = tour.item_discount[i];
            var from = new Date(item_discount.discount.from_discount_date).setHours(0, 0, 0, 0)
            var to = new Date(item_discount.discount.to_discount_date).setHours(0, 0, 0, 0)

            if (nowDate >= from && nowDate < to) {
                discount = item_discount.discount.disc_value
            }
        }
    }
    if (discount == 0 && tour.discount > 0) {
        var from = new Date(tour.from_discount_date).setHours(0, 0, 0, 0)
        var to = new Date(tour.to_discount_date).setHours(0, 0, 0, 0)

        if (nowDate >= from && nowDate < to) {
            discount = tour.discount
        }
    }
    return discount
}

function getGroupCost(itinerary_season) {
    var group = []
    var nowDate = new Date().setHours(0, 0, 0, 0)
    for (let index = 0; index < itinerary_season.length; index++) {
        const season = itinerary_season[index];
        var from = new Date(season.season_itinerary.start_date).setHours(0, 0, 0, 0)
        var to = new Date(season.season_itinerary.end_date).setHours(0, 0, 0, 0)
        if (nowDate >= from && nowDate < to) {
            group = season.seasonal_group_cost
        }
    }
    return group
}

const buildUrl = (url, parameters) => {
    var qs = "";
    for (var key in parameters) {
        var value = parameters[key];
        if (!value) {
            continue
        }
        value = value.toString().split('\"').join('"');
        qs += key + "=" + encodeURIComponent(value) + "&";
    }
    if (qs.length > 0) {
        qs = qs.substring(0, qs.length - 1); //chop off last "&"
        url = url + "?" + qs;
    }
    return url;
}
const windowName = `sbg-window-${Math.random()}`;

const height = 400;
const width = 400;

const top = Math.max(0, (window.screen.height - height) / 2);
const left = Math.max(0, (window.screen.width - width) / 2);

const specs = `
      height=${height},
      width=${width},
      top=${top},
      left=${left},
      status=0,
      toolbar=0,
      directories=0,
      location=0,
      menubar=0,
      resizable=1,
      scrollbars=1`

class RoundTourDetails extends Component {

    constructor(props) {
        super(props);

        const { name } = this.props.match.params;
        this.state = {
            currentPage: 1,
            reviewsPerPage: 3,
            update: true,
            stars: 0,
            percentage: 0,
            tab: 1,
            nowDate: new Date().setHours(0, 0, 0, 0),
            dateBegin: new Date().setHours(0, 0, 0, 0),
            dateEnd: new Date().setHours(0, 0, 0, 0),
            date: new Date(),
            location: "",
            adult_c: 0,
            child_c: 0,
            infant_c: 0,
            price: 0,
            adult_pax_from: 0,
            adult_pax: 0,
            child_pax_from: 0,
            child_pax: 0,
            discount: 0,
            group_cost: null,
            contact_price: true,
            starting: true
        }
        this.props.getRoundTourDetails(name)
    }
    componentDidMount() {
        const savedState = sessionStorage.getItem("tourState");
        if (savedState) {
            const state = JSON.parse(savedState);

            if (state.date) {
                state.date = new Date(state.date);
            }
            this.setState(state);
        }
    }

    componentDidUpdate(prevProps) {
        const savedState = sessionStorage.getItem("tourState");
        if (
            prevProps.tourDetailsReducer.tour !== this.props.tourDetailsReducer.tour &&
            this.props.tourDetailsReducer.tour && !savedState
        ) {
            const tour = this.props.tourDetailsReducer.tour;
            this.setState({
                update: false,
                stars: tour.stars,
                percentage: tour.stars > 0 ? (tour.stars / 5) * 100 : 0,
                dateBegin: new Date(tour.from_price_date).setHours(0, 0, 0, 0),
                dateEnd: new Date(tour.to_price_date).setHours(0, 0, 0, 0),
                group_cost: tour.itinerary_season.length > 0 ? getGroupCost(tour.itinerary_season) : 0,
                adult_pax: tour.itinerary_season.length > 0 ? getAdultChild(getGroupCost(tour.itinerary_season), "Adult").pax : 0,
                adult_pax_from: tour.itinerary_season.length > 0 ? getAdultChild(getGroupCost(tour.itinerary_season), "Adult").from_pax : 0,
                child_pax: tour.itinerary_season.length > 0 ? getAdultChild(getGroupCost(tour.itinerary_season), "Child").pax : 0,
                child_pax_from: tour.itinerary_season.length > 0 ? getAdultChild(getGroupCost(tour.itinerary_season), "Child").from_pax : 0,
                price: tour.itinerary_season.length > 0 ? getPrice(getGroupCost(tour.itinerary_season)) : 0,
                contact_price: tour.itinerary_season.length > 0 && getPrice(getGroupCost(tour.itinerary_season)) == 0 ? false : true,
                discount: getDiscount(tour),
            });

        }
    }

    handleTabChange = (value) => {
        this.setState({
            tab: value
        })
    }

    handlePageChange = (pageNumber) => {
        this.setState({
            currentPage: pageNumber,
        });
    };

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, () => this.priceCalculate(false));
    }

    handleDateChange = (value) => {
        this.setState({
            date: value,
            discount: getDiscount(this.props.tourDetailsReducer.tour, value)
        }, () => this.priceCalculate(false));
    }


    handleLocChange = (event) => {
        var loc_group = this.props.tourDetailsReducer.tour.itinerary_season.find((loc) => loc.location == event.target.value)
        this.setState({
            location: loc_group.location,
            adult_c: 0,
            child_c: 0,
            infant_c: 0,
            group_cost: loc_group.location_group_cost,
            adult_pax: getAdultChild(loc_group, "Adult").pax,
            adult_pax_from: getAdultChild(loc_group, "Adult").from_pax,
            child_pax: getAdultChild(loc_group, "Child").pax,
            child_pax_from: getAdultChild(loc_group, "Child").from_pax,
            price: getPrice(loc_group),
            contact_price: getPrice(loc_group) == 0 ? false : true,
            starting: true
        })
    }

    priceCalculate = () => {
        var state = this.state
        var date = new Date(state.date).setHours(0, 0, 0, 0)
        var adult_price = 0
        var child_price = 0
        if (state.adult_c > 0 && date >= state.dateBegin && date < state.dateEnd) {
            for (let index = 0; index < state.group_cost.length; index++) {
                var groupCost = state.group_cost[index];
                adult_price = groupCost.type == 0 && groupCost.from_number <= state.adult_c && groupCost.to_number >= state.adult_c ? groupCost.price : adult_price
                child_price = groupCost.type == 1 && groupCost.from_number <= state.child_c && groupCost.to_number >= state.child_c ? groupCost.price : child_price

            }
        }

        this.setState({
            price: (adult_price > 0 ? (state.adult_c * adult_price) : 0) + (child_price > 0 && state.child_c > 0 ? (state.child_c * child_price) : 0),
            starting: false
        })
    }


    handleBooking = () => {

        sessionStorage.setItem(
            "tourState",
            JSON.stringify(this.state)
        );

        this.props.handleBooking({
            date: new Date(this.state.date).toLocaleDateString('en-GB'),
            adult: this.state.adult_c,
            child: this.state.child_c,
            infant: this.state.infant_c,
            price: this.state.price,
            discount: this.state.discount,
            type: "Round Tour"
        }, this.props.tourDetailsReducer.tour)

        setTimeout(() => {
            this.props.history.push("/confirm-reserve")
        }, 1000);
    }

    handleReviewTab = () => {
        this.handleTabChange(6)

        setTimeout(() => {
            const element = document.querySelector('#tab6');

            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }, 100);
    }

    handleFbShare = () => {
        const url = buildUrl('https://www.facebook.com/sharer/sharer.php', {
            'u': document.URL
        });
        window.open(url, windowName, specs);
    }

    handleTwitterShare = () => {
        const url = buildUrl('http://twitter.com/intent/tweet', {
            'url': document.URL
        });
        window.open(url, windowName, specs);
    }

    handleLinkedInShare = () => {
        const url = buildUrl('http://www.linkedin.com/shareArticle', {
            'mini': 'true',
            'url': document.URL
        });
        window.open(url, windowName, specs);
    }

    render() {

        const { reviews, reviewsList, images, tour, str_counts, categories, related_tours, max_day } = this.props.tourDetailsReducer;
        const { currentPage, reviewsPerPage, adult_pax, child_pax } = this.state;
        var state = this.state

        const banners = getBannerImages(tour)

        const indexOfLastReview = currentPage * reviewsPerPage;
        const indexOfFirstReview = indexOfLastReview - reviewsPerPage;

        const currentReviews = reviewsList.slice(
            indexOfFirstReview,
            indexOfLastReview
        );

        const totalPages = Math.ceil(reviewsList.length / reviewsPerPage);

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />
            <div className='tour-details'>
                {tour != null ?
                    <div className='main-container'>

                        <div className="page-title">
                            <div className="container title-cont">
                                <div className="row">
                                    <div className="col-lg-12 title-inner tour-details-breadcrumb">
                                        <div className="breadcrumb-links">
                                            <a href="/">Home</a>
                                            <span className="sep"></span>
                                            <a href="/round-tours">Round Tours </a>
                                            <span className="sep"></span>
                                            <a>{tour.name}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contentwrap">
                            <div className="introwrap">
                                <div className="tour-content-wrap">
                                    <div className='container'>
                                        <div className='row'>

                                            <div class="col-12 tour-sub-heading">
                                                <div class="tour-page-title">
                                                    <h4>{tour.name}</h4>
                                                </div>
                                                {reviews !== null && reviews.total_count > 0 ?
                                                    <div className="tour-info-wrap">
                                                        <div className="tour-info-value">
                                                            <div className="tourbox-bottom-col2 star-align">
                                                                <div className="star-rating" title="100%">
                                                                    <div className="back-stars-list">
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>
                                                                        <i className="fa fa-star" aria-hidden="true"></i>

                                                                        <div className="front-stars-list" style={{ width: this.state.percentage + "%" }}>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                            <i className="fa fa-star" aria-hidden="true"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null}
                                                <div class="sub-heading-tag"><span>Location :</span>  {tour.itinerary_start_city.name} </div>
                                                <div class="sub-heading-tag"><span>Duration :</span>  {tour.itinerary_days.length} Days {tour.itinerary_days.length - 1} Nights </div>
                                            </div>
                                            <div className="col-lg-9 tours-wrap">
                                                <div className="tour-details-wrap">
                                                    <div className="slider-section-detail-page">
                                                        {state.stars > 0 ? <div className="tour-rating-badge"><span>{Number(state.stars || 0).toFixed(1)}</span>Rating</div> : <div className="tour-rating-badge"><span>No</span>Ratings yet</div>}
                                                        <div className="single-page" >
                                                            {banners.length > 0 ? (<PhotoGallery
                                                                key={tour.id + "-" + banners.length}
                                                                images={banners}
                                                            />
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    <div class="row">

                                                        <div className='col-lg-4 search-side'>
                                                            <div className="tour-searchwrap">
                                                                <div className="tour-search-title">
                                                                    <h4>SEARCH MORE TOURS</h4>
                                                                </div>
                                                                <br />
                                                                <div className="form-inner">
                                                                    <div className="travel-duration-wrap">
                                                                        <h4>Tour Duration</h4>
                                                                        <div className="form-group">
                                                                            <div className="select-drop-arrow"></div>
                                                                            <select name="duration" className="form-control" type="text">
                                                                                <option data-div="full" value="">All</option>
                                                                                {[...Array(max_day)]
                                                                                    .map((_, index) => (<option
                                                                                        key={index}
                                                                                        value={index + 1}
                                                                                        className="locationoptions"
                                                                                    >
                                                                                        {index + 1} {index == 0 ? "Day" : "Days"}
                                                                                    </option>))}

                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                            </div>



                                                            <div className="tour-searchwrap">
                                                                <div className="line"></div>
                                                                <div className="form-inner">
                                                                    <div className="travel-duration-wrap">
                                                                        <h4>Tour Rattings</h4>
                                                                        <div className="form-group" style={{ fontFamily: "FontAwesome sans-serif" }}>
                                                                            {str_counts != null ? str_counts.map((star, index) => (<>
                                                                                {star == 1 ? <label key={index} className="radio form-control" style={{ fontSize: 20, fontWeight: 900, paddingTop: 0, paddingBottom: 0 }}>
                                                                                    <input type="radio" name="rating" value={index + 1} style={{ marginLeft: "-18px", marginTop: 10 }} />
                                                                                    {Array.from({ length: index + 1 }, () => "★ ").join("")}
                                                                                    {Array.from({ length: str_counts.length - (1 + index) }, () => " ☆").join("")}
                                                                                </label> : null}</>)) : null}
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                <br />
                                                            </div>

                                                            <div className="tour-searchwrap">
                                                                <div className="line"></div>
                                                                <div className="form-inner">

                                                                    <div className="travel-duration-wrap">
                                                                        <h4>Tour Category</h4>

                                                                        <div className="form-group">
                                                                            <div className="select-drop-arrow"></div>
                                                                            <select name="duration" className="form-control" type="text">
                                                                                <option data-div="full" value=""> Select Category </option>
                                                                                {categories.length > 0 ? categories.map((cat) => (
                                                                                    <option data-div="full" value={cat.id}>{cat.name}</option>
                                                                                )) : null}
                                                                            </select>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                <br />
                                                            </div>


                                                            <div className="tour-searchwrap">
                                                                <div className="line"></div>

                                                                <div className="form-inner">

                                                                    <div className="travel-duration-wrap">
                                                                        <h4>Price Range</h4>
                                                                        <div className="form-group">
                                                                            <label className="radio form-control">
                                                                                <input type="radio" name="range" value="100" /> 0 - 100
                                                                            </label>
                                                                            <label className="radio form-control">
                                                                                <input type="radio" name="range" value="500" /> 100 - 500
                                                                            </label>
                                                                            <label className="radio form-control">
                                                                                <input type="radio" name="range" value="1000" /> 500 - 1000
                                                                            </label>
                                                                            <label className="radio form-control">
                                                                                <input type="radio" name="range" value="1500" /> 1000 - more
                                                                            </label>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <br />
                                                            </div>
                                                            <button type="submit" className="btn tour">SEARCH</button>
                                                        </div>
                                                        <div className='col-lg-8 col-md-9 col-12'>
                                                            <p> <div dangerouslySetInnerHTML={{ __html: tour.description }} /></p>
                                                            <div className="tour-tabwrap review-tab">

                                                                <ul className="tabs">
                                                                    <li onClick={() => this.handleTabChange(1)} className={"review-tab" + (this.state.tab == 1 ? " active" : "")} rel="tab1">Itinerary</li>
                                                                    <li onClick={() => this.handleTabChange(2)} className={"review-tab" + (this.state.tab == 2 ? " active" : "")} rel="tab2">Includes</li>
                                                                    <li onClick={() => this.handleTabChange(3)} className={"review-tab" + (this.state.tab == 3 ? " active" : "")} rel="tab3">Excludes</li>
                                                                    <li onClick={() => this.handleTabChange(4)} className={"review-tab" + (this.state.tab == 4 ? " active" : "")} rel="tab4">Conditions</li>
                                                                    <li onClick={() => this.handleTabChange(5)} className={"review-tab" + (this.state.tab == 5 ? " active" : "")} rel="tab5"> Know before you go</li>
                                                                    {reviewsList.length > 0 ?
                                                                        <li onClick={() => this.handleTabChange(6)} className={"review-tab" + (this.state.tab == 6 ? " active" : "")} rel="tab6">Reviews ({this.props.tourDetailsReducer.reviews.total_count}) </li> : null}
                                                                </ul>
                                                                <div className="tab_container">
                                                                    {this.state.tab == 1 ?
                                                                        <div id="tab1" className="tab_content">
                                                                            {tour.itinerary_days
                                                                                ?.map((plan, index) => (
                                                                                    <div key={plan.id || index} className="tour-list">
                                                                                        <div className="day-wrap">
                                                                                            <div className="day-no">
                                                                                                {index + 1} Day
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="tour-list-detail">
                                                                                            <h4>{index == 0 ? tour.itinerary_start_city?.name : tour.itinerary_days[index - 1].ending_city?.name} - {plan.ending_city?.name}</h4>
                                                                                            <p dangerouslySetInnerHTML={{ __html: plan.content }} />
                                                                                        </div>
                                                                                    </div>
                                                                                ))}

                                                                        </div> : null}

                                                                    {this.state.tab == 2 ?
                                                                        <div id="tab2" className="tab_content">
                                                                            <div className="tour-list">
                                                                                <div className="day-wrap">
                                                                                </div>
                                                                                <div className="tour-list-detail">
                                                                                    <p dangerouslySetInnerHTML={{ __html: tour.tour_includes }} />
                                                                                </div>
                                                                            </div>


                                                                        </div> : null}

                                                                    {this.state.tab == 3 ?
                                                                        <div id="tab3" className="tab_content">
                                                                            <div className="tour-list">
                                                                                <div className="tour-list-detail">
                                                                                    <p dangerouslySetInnerHTML={{ __html: tour.tour_excludes }} />
                                                                                </div>
                                                                            </div>


                                                                        </div> : null}

                                                                    {this.state.tab == 4 ?
                                                                        <div id="tab4" className="tab_content">
                                                                            <div className="tour-list row">
                                                                                <div className="tour-list-detail col-12" dangerouslySetInnerHTML={{ __html: tour.conditions }} />
                                                                                <div className="tour-list-detail">
                                                                                    {tour.policies > 0 ?

                                                                                        <div>
                                                                                            <h4>Cancellation Policy</h4>
                                                                                            <ul>
                                                                                                <ul>
                                                                                                    {tour?.policies?.map((policy, index) => (
                                                                                                        policy.tour_type === 1 && policy.policy ? (
                                                                                                            <li key={index}>
                                                                                                                {policy.policy.policy}
                                                                                                            </li>
                                                                                                        ) : null
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </ul>
                                                                                        </div>
                                                                                        : null}
                                                                                </div>
                                                                            </div>

                                                                        </div> : null}

                                                                    {this.state.tab == 5 ?
                                                                        <div id="tab5" className="tab_content">
                                                                            <div className="tour-list">
                                                                                <div className="tour-list-detail" style={{ paddingLeft: 76, width: "100%" }}>
                                                                                    <p dangerouslySetInnerHTML={{ __html: tour.know_before }} />
                                                                                </div>
                                                                            </div>


                                                                        </div> : null}
                                                                    {this.state.tab == 6 && reviewsList.length > 0 ? (

                                                                        <>
                                                                            <div id="tab6" className="tab_content" style={{ scrollMarginTop: 200 }}>
                                                                                <div className="client-listing-review-wrap">

                                                                                    <h2>Client Reviews</h2>

                                                                                    <div className="client-ratings-and-stars">

                                                                                        <div className="client-star-rating-view">

                                                                                            <h6>
                                                                                                {Number(
                                                                                                    tour?.stars || 0
                                                                                                ).toFixed(1)}
                                                                                            </h6>

                                                                                            <div className="star-rates">
                                                                                                {[1, 2, 3, 4, 5].map((i) => {
                                                                                                    const stars = tour?.stars || 0;

                                                                                                    if (i <= stars) {
                                                                                                        return (<i key={i} className="fa-solid fa-star"></i>
                                                                                                        );
                                                                                                    } else {
                                                                                                        return (
                                                                                                            <i key={i} className="fa-regular fa-star"></i>
                                                                                                        );
                                                                                                    }
                                                                                                })}
                                                                                            </div>

                                                                                            <span>
                                                                                                {
                                                                                                    reviews.total_count
                                                                                                }{" "}
                                                                                                reviews
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className="client-rating-count-view">

                                                                                            <h3 id='reviews-h3'>
                                                                                                Total review count and overall reviews
                                                                                            </h3>

                                                                                            <div className="all-stars">

                                                                                                {reviews.rate.map(
                                                                                                    (rate, index) => (
                                                                                                        <div className="single-star" key={index}>
                                                                                                            <h5>{rate.rate} Stars</h5>

                                                                                                            <div className="star-count-bar">
                                                                                                                <span className="highlighted-bar" style={{ width: `${rate.percentage}%`, }}></span>
                                                                                                            </div>

                                                                                                            <h6>{rate.count}</h6>
                                                                                                        </div>
                                                                                                    )
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div id="scroll-review"></div>

                                                                                    {currentReviews.length > 0
                                                                                        ? currentReviews.map((review, pKey) => (
                                                                                            <div
                                                                                                className="single-client-reviews-listing"
                                                                                                key={pKey}
                                                                                            >
                                                                                                <div className="client-review-top-det">
                                                                                                    <h4>
                                                                                                        {review.booking.name}

                                                                                                        <span>
                                                                                                            {" "}
                                                                                                            {review.booking.nationality}
                                                                                                        </span>
                                                                                                    </h4>

                                                                                                    <div className="star-rates">
                                                                                                        {[1, 2, 3, 4, 5].map((i) =>
                                                                                                            i <= review.rate ? (
                                                                                                                <i
                                                                                                                    key={i}
                                                                                                                    className="fa-solid fa-star"
                                                                                                                ></i>
                                                                                                            ) : (
                                                                                                                <i
                                                                                                                    key={i}
                                                                                                                    className="fa-regular fa-star"
                                                                                                                ></i>
                                                                                                            )
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>

                                                                                                <p>{review.review}</p>

                                                                                                <div className="added-client-images">
                                                                                                    <div className="gallery">
                                                                                                        {images
                                                                                                            ?.filter(
                                                                                                                (image) =>
                                                                                                                    image.day_tour_review_id ===
                                                                                                                    review.id
                                                                                                            )
                                                                                                            .map((image, key) => (
                                                                                                                <a
                                                                                                                    key={key}
                                                                                                                    href={`/uploads/review/day_tour/${image.name}`}
                                                                                                                    data-lightbox={`group-${pKey}`}
                                                                                                                    data-title=""
                                                                                                                >
                                                                                                                    <img
                                                                                                                        src={`/uploads/review/day_tour/${image.name}`}
                                                                                                                        alt={`Thumbnail ${key}`}
                                                                                                                    />
                                                                                                                </a>
                                                                                                            ))}
                                                                                                    </div>
                                                                                                </div>

                                                                                                <h5>
                                                                                                    Review on{" "}
                                                                                                    {new Date(
                                                                                                        review.created_at
                                                                                                    ).toLocaleDateString("en-US", {
                                                                                                        month: "short",
                                                                                                        day: "2-digit",
                                                                                                        year: "numeric",
                                                                                                    })}
                                                                                                </h5>
                                                                                            </div>
                                                                                        ))
                                                                                        : null}
                                                                                    <div className="pagination-wrapper">
                                                                                        <button
                                                                                            disabled={currentPage === 1}
                                                                                            onClick={() =>
                                                                                                this.handlePageChange(currentPage - 1)
                                                                                            }
                                                                                        >
                                                                                            « Previous
                                                                                        </button>

                                                                                        {[...Array(totalPages)].map((_, index) => (
                                                                                            <button
                                                                                                key={index}
                                                                                                className={
                                                                                                    currentPage === index + 1 ? "active" : ""
                                                                                                }
                                                                                                onClick={() =>
                                                                                                    this.handlePageChange(index + 1)
                                                                                                }
                                                                                            >
                                                                                                {index + 1}
                                                                                            </button>
                                                                                        ))}

                                                                                        <button
                                                                                            disabled={currentPage === totalPages}
                                                                                            onClick={() =>
                                                                                                this.handlePageChange(currentPage + 1)
                                                                                            }
                                                                                        >
                                                                                            Next »
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>

                                                                    ) : null}
                                                                </div>

                                                            </div>

                                                            {related_tours.length > 0 ? <div class="related-tours-wrap">
                                                                <h4>Related Tours</h4>

                                                                <div class="related-tour-lists">
                                                                    {related_tours.map((tour, tIndex) => (<div class="rt-wrapper" key={tIndex}>
                                                                        <div class="rt-info">
                                                                            <a href={getURL(tour)}>
                                                                                <h6>{tour.name}</h6>
                                                                            </a>
                                                                            {tour.itinerary_start_city?.name}
                                                                        </div>

                                                                    </div>))}

                                                                </div>
                                                            </div> : null}
                                                        </div>

                                                    </div>




                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-priceform pr-gap">
                                                <div className="price-contents">
                                                    <div className="price-form-details">
                                                        <div className="col-wrap">
                                                            <div className="form-group price-chk">
                                                                <label id="label-bold">Tour Date</label>

                                                                <DatePicker
                                                                    selected={state.date}
                                                                    onChange={(date) => this.handleDateChange(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    minDate={new Date}
                                                                />
                                                            </div>


                                                            <div className="subfield">
                                                                <label id="selectedadult">
                                                                    <span className="t1">Adult </span><br /><span className="t2">Age 12 & Above</span></label>
                                                                <div className="select-drop-arrow"></div>
                                                                <select className="form-control" id="adultcount" aria-labelledby="adultpax" value={this.state.adult_c} name="adult_c" onChange={this.handleChange}>
                                                                    <option value={0} className="locationoptions">0</option>
                                                                    {[...Array(adult_pax)]
                                                                        .map((_, index) => index + 1)
                                                                        .filter(num => num >= state.adult_pax_from)
                                                                        .map(num => (
                                                                            <option
                                                                                key={num}
                                                                                value={num}
                                                                                className="locationoptions"
                                                                            >
                                                                                {num}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-wrap">
                                                            <div className="subfield pax-boxes adultdropbox">
                                                                <label id="selectedchild"><span className="t1">Child </span><br /><span className="t2">Age 05 to
                                                                    11</span></label>
                                                                <div className="select-drop-arrow"></div>
                                                                <select className="form-control" id="childcount" aria-labelledby="childpax" value={this.state.child_c} name="child_c" onChange={this.handleChange}>
                                                                    <option value={0} className="locationoptions">0</option>

                                                                    {[...Array(child_pax)]
                                                                        .map((_, index) => index + 1)
                                                                        .filter(num => num >= state.child_pax_from)
                                                                        .map(num => (
                                                                            <option
                                                                                key={num}
                                                                                value={num}
                                                                                className="locationoptions"
                                                                            >
                                                                                {num}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-wrap">
                                                            <div className="subfield">
                                                                <label id="selectedinfants"><span className="t1">Infant </span><br /><span className="t2">Age below
                                                                    04</span></label>
                                                                <div className="select-drop-arrow"></div>
                                                                <select id="infantscount" className="form-control" aria-labelledby="infantpax" value={this.state.infant_c} name="infant_c" onChange={this.handleChange}>
                                                                    <option className="infantsoptions" data-value="0">0</option>
                                                                    <option className="infantsoptions inf" data-value="1">1</option>
                                                                    <option className="infantsoptions inf" data-value="2">2</option>
                                                                    <option className="infantsoptions inf" data-value="3">3</option>
                                                                    <option className="infantsoptions inf" data-value="4">4</option>
                                                                    <option className="infantsoptions inf" data-value="5">5</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="clear"></div>
                                                        <div className="price-form-title">

                                                            {state.contact_price && tour.itinerary_season.length > 0 && state.nowDate < state.dateEnd ? <div>
                                                                <div className="price-form-title-col1 text-uppercase" id="initial">{state.starting ? "Starting From" : "Total"} </div>
                                                                <div className="price-form-title-col2">
                                                                    <span>USD</span><br />
                                                                    <span className="pricewrap1" id="day-tour-price-bottom"> {Number(state.price).toFixed(2)} </span>
                                                                </div>

                                                                <div className="clear"></div>
                                                                {!state.starting && state.price > 0 && state.discount > 0 ? <div className="discount-price-tag">
                                                                    Deal <span id="round-tour-discount"> {Number(state.price - ((state.price * state.discount) / 100)).toFixed(2)} </span>
                                                                </div> : null}

                                                            </div>
                                                                : <span className="pricewrap1">Contact for pricing</span>}

                                                        </div>

                                                        <div className="row quote-buttons" id="showprice" style={{
                                                            display: state.starting || state.price === 0 ? "none" : "block"
                                                        }}>
                                                            <button id="form-check" className="btn availability" onClick={this.handleBooking}>Book Now</button>
                                                        </div>


                                                        <div className="subfield-bottom">
                                                            <p>Share Tour with Friends</p>

                                                            <div className="socialwrap">
                                                                <ul>
                                                                    <script src='https://connect.facebook.net/en_US/all.js'></script>
                                                                    <li onClick={this.handleFbShare}><a id="fb_share"><img src={tourFb} alt="" width="23" height="23" /></a></li>
                                                                    <li onClick={this.handleTwitterShare}><a id="twitter_share"><img src={tourTw} alt="" width="23" height="23" /></a></li>
                                                                    <li onClick={this.handleLinkedInShare}><a id="linkedin_share"><img src={tourLn} alt="" width="23" height="23" /></a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="timeline">
                                                    {tour.itinerary_days != undefined && tour.itinerary_days.length > 0 ? tour.itinerary_days.map((itinerary, index) => (<div>
                                                        {index == 0 && tour.itinerary_routes != undefined ? <div class="timeline-item">
                                                            <div class="timeline-dot">
                                                            </div>
                                                            <div class="timeline-content">
                                                                <h4>{tour.itinerary_routes.start.name}</h4>
                                                            </div>
                                                        </div> : null}
                                                        {itinerary.itinerary_excursions.length > 0 ? <div class="timeline-item">
                                                            <div class="timeline-content">
                                                                <ul class="custom-list">
                                                                    {itinerary.itinerary_excursions.filter(activity => activity.excursion).map((activity) => (
                                                                        <li key={activity.excursion.id}>
                                                                            {activity.excursion.name}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div> : null}

                                                        {itinerary.ending_city != undefined ? <div class="timeline-item">
                                                            <div class="timeline-dot">

                                                            </div>
                                                            <div class="timeline-content">
                                                                <h4>{itinerary.ending_city.name}</h4>
                                                            </div>
                                                        </div> : null}
                                                        {index + 1 === tour?.itinerary_days?.length &&
                                                            tour?.itinerary_routes?.end?.name &&
                                                            itinerary?.ending_city?.name !== tour?.itinerary_routes?.end?.name && (
                                                                <div className="timeline-item">
                                                                    <div className="timeline-dot"></div>
                                                                    <div className="timeline-content">
                                                                        <h4>{tour.itinerary_routes.end.name}</h4>
                                                                    </div>
                                                                </div>
                                                            )}</div>
                                                    )) : null}
                                                </div>

                                            </div>



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
            </div>
            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(RoundTourDetails);